// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__34elE","upload":"Small_upload__2vbZI","imageWrap":"Small_imageWrap__2BdS4","removeBtn":"Small_removeBtn__266P6"};